import { NgModule } from '@angular/core';
import { TestQueryComponent } from './test-query.component';
import { SidebarComponent } from './component/sidebar/sidebar.component';
import { TabbarComponent } from './component/tabbar/tabbar.component';
import { LoginComponent } from './pages/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { RegisterComponent } from './pages/register/register.component';
import { TestQuqeryRoutingModule } from './test-query-routing.module';
import { ChileComponent } from './pages/chile/chile.component'
import { TypeService } from './service/lcontype/type.service';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NzIconModule } from 'ng-zorro-antd/icon';
import { IconsProviderModule } from './icons-provider.module';
import { NgZorroAntdModule, NZ_I18N, en_US, zh_CN } from 'ng-zorro-antd';
import { ReactiveFormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzPopoverModule } from 'ng-zorro-antd/popover';

@NgModule({
  declarations: [
    TestQueryComponent,
    LoginComponent,
    HomeComponent,
    SidebarComponent,
    TabbarComponent,
    RegisterComponent,
    ChileComponent
  ],
  imports: [
    TestQuqeryRoutingModule,
    BrowserModule,
    IconsProviderModule,
    NgZorroAntdModule,
    FormsModule,
    HttpClientModule,
    NzIconModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    NzInputModule,
    NzPopoverModule
  ],
  providers: [
    { provide: NZ_I18N, useValue: zh_CN },
    TypeService,
  ],
  exports: [TestQueryComponent],
  entryComponents: [
    ChileComponent
  ]
})
export class TestQueryModule { }
